/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/mobile-v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WeekCalendar from '@/components/WeekCalendar/WeekCalendar.vue';
import Scroll from '@/components/Scroll/Scroll';
export default {
  name: 'OrderMeeting',
  components: {
    WeekCalendar: WeekCalendar,
    Scroll: Scroll
  },
  data: function data() {
    return {
      timestamp: 0,
      //当前时间的时间戳
      eventList: [],
      //活动/事件数组
      roomList: [],
      currDate: '',
      //当前日期
      curPage: 1,
      //当前页
      totalPage: 0,
      //总页数
      pageNum: 20,
      //每页条数
      pullDownRefresh: {
        threshold: 40,
        // 下拉多少开始刷新
        stop: 20 // 下拉回弹到多少停住

      },
      pullUpLoad: {
        threshold: 25
      },
      isPullDown: false,
      // 正在下拉刷新
      isPullUp: false,
      // 正在上拉加载
      emptyShow: false,
      initFlag: true,
      curTime: '',
      //当前时间
      isAuthor: null,
      //权限
      show: false
    };
  },
  computed: {},
  methods: {
    myClick: function myClick() {
      this.$router.push({
        path: '/MyMeetingOrder'
      });
    },

    /**
     * @function获取当前日期
     *      wzx
     *   2019.01.22
     **/
    getSysDate: function getSysDate() {
      var _this = this;

      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          _this.currDate = data.sysDate.substring(0, 10);
          _this.curTime = data.sysDate;
          _this.timestamp = _this.$utils.DateUtils.getTimeStamp(data.sysDate) * 1000;

          _this.getMeetingList();
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取当前日期下的会议室列表及状态
     *      wzx
     *   2019.01.22
     **/
    getMeetingList: function getMeetingList() {
      var _this2 = this;

      this.$api.Meeting.getMeetingList({
        page_index: this.curPage,
        page_size: this.pageNum,
        search: {
          cdate: this.currDate,
          userSerial: this.$utils.Store.getItem('userSerial')
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.roomList = data.records;
          _this2.totalPage = data.total_page;
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      }).finally(function () {
        _this2.updateScroll(_this2.curPage <= _this2.totalPage);
      });
    },

    /**
     * @function获取当前日期下的与自己有关的会议日期列表
     *      wzx
     *   2019.01.23
     **/
    getMyMeetingDateList: function getMyMeetingDateList() {
      var _this3 = this;

      this.$api.Meeting.getMyMeetingDateList({
        userSerial: this.$utils.Store.getItem('userSerial')
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this3.$code.success) {
          _this3.$utils.Tools.toastShow(msg);
        } else {
          _this3.eventList = data;
        }
      }).catch(function () {
        _this3.$utils.Tools.httpError();
      });
    },
    onPullingDown: function onPullingDown() {
      if (this.isPullDown) return;
      this.isPullDown = true; // 下拉刷新

      this.list = [];
      this.curPage = 1;
      this.getMeetingList();
    },
    onPullingUp: function onPullingUp() {
      if (this.isPullUp) return;
      this.isPullUp = true;
      this.curPage++;

      if (this.curPage > this.totalPage) {
        this.updateScroll(false);
        return;
      }

      this.getMeetingList();
    },
    // 刷新 Scroll 状态
    updateScroll: function updateScroll(flag) {
      this.isPullDown = false;
      this.isPullUp = false;
      this.$refs.scroll.forceUpdate(flag);
    },
    roomClick: function roomClick(obj) {
      if (!this.isAuthor) {
        //   return this.$utils.Tools.toastShow('暂无权限请联系管理员!');
        return this.show = true;
      }

      this.$utils.Store.setLocalItem('roomId', obj.depSerial);
      this.$utils.Store.setLocalItem('roomName', obj.depName);
      this.$utils.Store.setItem('devices', JSON.stringify(obj.roomResource));
      this.$router.push({
        name: 'MeetingRoomDetail',
        query: {
          roomId: this.$utils.Store.getLocalItem('roomId'),
          curTime: obj.kssj ? obj.kssj : this.curTime,
          roomName: this.$utils.Store.getLocalItem('roomName'),
          devices: this.$utils.Store.getItem('devices')
        }
      });
    },

    /**
     * @function点击获取当前日期下的会议室列表
     *      wzx
     *   2019.01.23
     **/
    monthClick: function monthClick(val) {
      this.currDate = val;
      this.getMeetingList();
    },

    /**
     * @function点击获取当前日期下的会议室列表
     *      wzx
     *   2019.01.23
     **/
    dayClick: function dayClick(val) {
      this.currDate = val;
      this.getMeetingList();
    },
    //判断是否有权限申请
    getAuther: function getAuther() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$api.Meeting.selectIsAuthorized({
                  userSerial: _this4.$utils.Store.getItem('userSerial')
                }).then(function (res) {
                  _this4.isAuthor = res.data;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.getSysDate();
    this.getMyMeetingDateList();
    this.getAuther();
  },
  mounted: function mounted() {
    this.$utils.Store.removeItem('curActive');
    this.$utils.Store.removeItem('meetingType');
  },
  destroyed: function destroyed() {}
};